module.exports = "/_next/static/images/front-411761b705255a041e99fca0eab26443.jpg";